import { Rectangle } from 'src/app/tools/rectangle';

export class CoordUtil {

  constructor() {

  }

  static getRotatedRectangleBoundingBox(angle:number, rect:Rectangle):Rectangle{

    let _rotatedW = this.rotate2D({x:rect.width, y:0} ,angle);
    let _rotatedH = this.rotate2D({x:0, y:rect.height} ,angle);

    let _tr = {x:rect.x+_rotatedW.x, y:rect.y+_rotatedW.y};
    let _br = {x:_tr.x+_rotatedH.x, y:_tr.y+_rotatedH.y};
    let _bl = {x:rect.x+_rotatedH.x, y:rect.y+_rotatedH.y};

    let _bbX = Math.min(rect.x, _tr.x, _br.x, _bl.x);
    let _bbY = Math.min(rect.y, _tr.y, _br.y, _bl.y);

    return new Rectangle(
      _bbX,
      _bbY,
      Math.max(rect.x, _tr.x, _br.x, _bl.x) - _bbX,
      Math.max(rect.y, _tr.y, _br.y, _bl.y) - _bbY,
    );
  }

  static rotate2D(vector, angle)
  {
    var theta = angle * Math.PI / 180; // radians
    var matrix = [Math.cos(theta),  Math.sin(theta)];

    return {
      x: vector.x * matrix[0] - vector.y * matrix[1],
      y: vector.x * matrix[1] + vector.y * matrix[0]
    };
  }

}
